import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import Home from "./pages/Home";
import Directory from "./pages/Directory";
import VenueDetail from "./pages/VenueDetail";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import { NewsList, NewsDetail } from "./pages/News";
import { Login, Register } from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import SubmitVenue from "./pages/SubmitVenue";
import SubmitEvent from "./pages/SubmitEvent";
import QuickGig from "./pages/QuickGig";
import PaymentStatus from "./pages/PaymentStatus";
import Admin from "./pages/Admin";
import TourDetail from "./pages/TourDetail";
import SubmitTour from "./pages/SubmitTour";
import Feedback from "./pages/Feedback";
import Activities from "./pages/Activities";
import Jobs from "./pages/Jobs";
import Noticeboard from "./pages/Noticeboard";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/directory/:category" element={<Directory />} />
            <Route path="/venue/:id" element={<VenueDetail />} />
            <Route path="/tour/:id" element={<TourDetail />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:id" element={<EventDetail />} />
            <Route path="/news" element={<NewsList />} />
            <Route path="/news/:slug" element={<NewsDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/submit" element={<SubmitVenue />} />
            <Route path="/dashboard/edit-venue/:id" element={<SubmitVenue />} />
            <Route path="/dashboard/submit-event" element={<SubmitEvent />} />
            <Route path="/dashboard/submit-tour" element={<SubmitTour />} />
            <Route path="/dashboard/edit-tour/:id" element={<SubmitTour />} />
            <Route path="/dashboard/edit-event/:id" element={<SubmitEvent />} />
            <Route path="/dashboard/quick-gig" element={<QuickGig />} />
            <Route path="/payment/status" element={<PaymentStatus />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/noticeboard" element={<Noticeboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
